import { Box, Typography } from "@mui/material";
import ContainedButton from "../../../../components/buttons/ContainedButton";
import OutlinedButton from "../../../../components/buttons/OutlinedButton";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { icons } from "../../../stack/environment/icons/iconExport";

const FirstWorkflowMessage = ({ onStartWithTemplate, onBuildFromScratch }) => {
  return (
    <Box
      sx={{
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
        width: "100%",
        height: "100%",
      }}
    >
      <SvgToIcon IconLogo={icons.FirstWorkflowIcon} width={"80px"} />
      <Typography variant="h6">Create your first workflow</Typography>
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={1}
        alignItems={"center"}
      >
        <Typography variant="body1">
          Choose a template to get started quickly, or build from scratch.
        </Typography>
      </Box>
      <Box display={"flex"} flexDirection={"row"} gap={2}>
        <ContainedButton
          color="primary"
          size="medium"
          onClick={onStartWithTemplate}
        >
          Start with template
        </ContainedButton>
        <OutlinedButton size="medium" onClick={onBuildFromScratch}>
          Build from scratch
        </OutlinedButton>
      </Box>
    </Box>
  );
};

export default FirstWorkflowMessage;
